import "react-app-polyfill/stable.js";
import "core-js";
import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App.jsx";
import reportWebVitals from "./reportWebVitals.js";
import { Provider } from "react-redux";
import store from "./store.js";
import { BrowserRouter } from "react-router-dom";
import axios from "axios";
import { setFavicon } from "./utils/faviconUtils.js";
import { isValidRedirectRoute } from "./utils/routeUtils.js";

// Global response interceptor to handle session invalidation / 401 Unauthorized
axios.interceptors.response.use(
  (response) => {
    if (response && response.data && (response.data.code === 401 || response.data.code === "401")) {
      const currentPath = window.location.pathname + window.location.search + window.location.hash;
      if (isValidRedirectRoute(currentPath)) {
        localStorage.setItem("lastRoute", currentPath);
      }
      localStorage.removeItem("ApiToken");
      if (window.location.pathname !== "/login") {
        window.location.href = "/login";
      }
    }
    return response;
  },
  (error) => {
    const is401 =
      error.response &&
      (error.response.status === 401 ||
        error.response.status === "401" ||
        error.response.data?.code === 401 ||
        error.response.data?.code === "401" ||
        error.response.data?.error === "Unauthenticated.");

    if (is401) {
      const currentPath = window.location.pathname + window.location.search + window.location.hash;
      if (isValidRedirectRoute(currentPath)) {
        localStorage.setItem("lastRoute", currentPath);
      }
      localStorage.removeItem("ApiToken");
      if (window.location.pathname !== "/login") {
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  }
);

// it persists across reloads/navigation; falls back to the default public favicon.
setFavicon(localStorage.getItem("OrgFavIcon"));

// To prevent repeated alerts for the same error
let hasHandledError = false;

window.addEventListener("error", function (event) {
  // Check if the error is specifically related to `this.window` being null
  if (
    !hasHandledError &&
    event.error &&
    event.error.message &&
    event.error.message.includes("this.window is null")
  ) {
    hasHandledError = true; // Set the flag to true to prevent duplicate handling

    // Display a user-friendly popup message
    alert(
      "An issue has been detected with your browser settings. Please enable popups or refresh the page."
    );

    // Redirect based on the current route
    setTimeout(() => {
      const currentPath = window.location.pathname;

      if (currentPath === "/elearning/content/player") {
        // Redirect to the catalog page
        window.location.href = "/user/catalog";
      } else if (currentPath === "/elearning/player") {
        // Redirect to the training library
        window.location.href = "/su/trainings/training-library";
      } else if (currentPath === "/elearning/content") {
        // Redirect to the course library
        window.location.href = "/admin/training-management/online-courses";
      } else if (window.history.length > 1) {
        // Navigate back to the previous route
        window.history.back();
      } else {
        // Reload the page if no history exists
        window.location.reload();
      }
    }, 0);

    return;
  }

  // For other runtime errors, log the error but avoid interrupting the user
  console.error("An error occurred:", event.error);
});

createRoot(document.getElementById("root")).render(
  <Provider store={store}>
    <BrowserRouter
      future={{ v7_relativeSplatPath: true, v7_startTransition: true }}
    >
      <App />
    </BrowserRouter>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// Register service worker if available
// if ('serviceWorker' in navigator) {
//   window.addEventListener('load', () => {
//     navigator.serviceWorker
//       .register('/service-worker.js')
//       .then((registration) => {
//         console.log('Service worker registered:', registration);
//       })
//       .catch((err) => {
//         console.error('Service worker registration failed:', err);
//       });
//   });
// }
